import { render } from "./Bill_Details.vue?vue&type=template&id=3d20dba6"
import script from "./Bill_Details.vue?vue&type=script&lang=js"
export * from "./Bill_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__